"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NotificationPriority;
(function (NotificationPriority) {
    NotificationPriority[NotificationPriority["low"] = 0] = "low";
    NotificationPriority[NotificationPriority["normal"] = 1] = "normal";
    NotificationPriority[NotificationPriority["high"] = 2] = "high";
})(NotificationPriority = exports.NotificationPriority || (exports.NotificationPriority = {}));
function createNotification(type, payload, id = undefined, display = 'autohide', closeable = 'closeable', priority = NotificationPriority.normal) {
    return {
        id,
        type,
        payload,
        options: {
            priority,
            display,
            closeable
        }
    };
}
exports.createNotification = createNotification;
//# sourceMappingURL=notification.js.map